// React
import { useEffect, useState } from "react";

// Resources
import { getFeatureFlagByName } from "../api/FeatureFlagsEndpointRequests";

// Components
import { Alert, IconButton, Box, useMediaQuery } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";

// Styles
import { useTheme } from "@mui/material/styles";

const PatientBanner = () => {
  const theme = useTheme();

  const [showBanner, setShowBanner] = useState(false);
  const [bannerText, setBannerText] = useState("");
  const [expanded, setExpanded] = useState(false);

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const shouldWrap = expanded || !isSmallScreen;

  useEffect(() => {
    const getFeatureFlag = async () => {
      const response = await getFeatureFlagByName("patientBannerText");
      setShowBanner(response.enabled);
      setBannerText(response.bannerText);
    };
    getFeatureFlag();
  }, []);

  useEffect(() => {
    // Always show full text on md+; collapse by default on xs/sm
    setExpanded(!isSmallScreen);
  }, [isSmallScreen]);

  if (!showBanner) return null;

  const handleToggle = () => setExpanded((prev) => !prev);

  return (
    <Alert
      severity="info"
      sx={{ textAlign: "left", cursor: isSmallScreen ? "pointer" : "default" }}
      tabIndex={isSmallScreen ? 0 : undefined}
      onClick={isSmallScreen ? handleToggle : undefined}
      action={
        isSmallScreen && (
          <IconButton
            color="inherit"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleToggle();
            }}
            aria-label={expanded ? "Collapse banner" : "Expand banner"}
          >
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        )
      }
    >
      <Box
        sx={{
          whiteSpace: shouldWrap ? "normal" : "nowrap",
          overflow: shouldWrap ? "visible" : "hidden",
          textOverflow: shouldWrap ? "clip" : "ellipsis",
          pr: isSmallScreen ? 1 : 0,
        }}
      >
        {bannerText}
      </Box>
    </Alert>
  );
};

export default PatientBanner;
